<template>
  <div class="p-4">
    <div class="row g-4 mb-5">
      <div class="col-md-4">
        <div class="card p-4 text-center">
          <div class="text-muted">Total Income</div>
          <div class="value">{{ formatCurrency(totalIncome) }}</div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card p-4 text-center">
          <div class="text-muted">Total Expense</div>
          <div class="value negative">{{ formatCurrency(totalExpense) }}</div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card p-4 text-center">
          <div class="text-muted">Net Result</div>
          <div
            class="value"
            :class="totalProfit >= 0 ? 'positive' : 'negative'"
          >
            {{ formatCurrency(totalProfit) }}
          </div>
        </div>
      </div>
    </div>

    <div class="card p-4">
      <div class="table-responsive">
        <table class="table table-bordered align-middle text-end mb-0">
          <thead>
            <tr>
              <th class="text-start">Category</th>
              <th v-for="(cat, index) in results.categories" :key="index">
                {{ cat }}
              </th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in results.rows"
              :key="rowIndex"
              :class="{
                'table-secondary': row.type === 'header',
                'table-light fw-bold': row.type === 'total',
                'table-success fw-bold': row.type === 'profit',
              }"
            >
              <td
                class="text-start"
                :class="{
                  'ps-4': row.type !== 'header',
                  'fw-bold': row.type === 'header',
                }"
              >
                {{ row.label }}
              </td>
              <template v-if="row.type === 'header'">
                <td :colspan="results.categories.length + 1"></td>
              </template>
              <template v-else>
                <td
                  v-for="(val, valIndex) in row.values"
                  :key="valIndex"
                  :class="{
                    negative:
                      row.type === 'expense' ||
                      (row.type === 'profit' && val < 0),
                    positive: row.type === 'profit' && val >= 0,
                  }"
                >
                  {{ formatCurrency(val) }}
                </td>
                <td
                  :class="{
                    negative:
                      row.type === 'expense' ||
                      (row.type === 'profit' && row.total < 0),
                    positive: row.type === 'profit' && row.total >= 0,
                    'fw-bold': true,
                  }"
                >
                  {{ formatCurrency(row.total) }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";
import { useStore } from "vuex";

export default {
  name: "IncomeStatement",
  data() {
    return {
      store: useStore(),
      results: {
        currency: "",
        categories: [],
        rows: [],
      },
    };
  },
  computed: {
    date() {
      return this.store.state.topBar.date;
    },
    totalIncome() {
      const row = this.results.rows.find((r) => r.key === "total_net_revenue");
      return row ? row.total : 0;
    },
    totalExpense() {
      return this.results.rows
        .filter((r) => r.type === "expense")
        .reduce((sum, r) => sum + (r.total || 0), 0);
    },
    totalProfit() {
      const row = this.results.rows.find((r) => r.type === "profit");
      return row ? row.total : 0;
    },
  },
  watch: {
    date: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      console.log(this.date);
      const from = this.date[0].toISOString().split("T")[0];
      const to = this.date[1].toISOString().split("T")[0];
      http
        .fetch(`/income-statement/data?from=${from}&to=${to}`)
        .then((data) => {
          this.currency = data.currency;
          this.results = data;
        });
    },
    formatCurrency(value) {
      if (value === null) return "";
      return new Intl.NumberFormat("hu-HU", {
        style: "currency",
        currency: this.currency,
        maximumFractionDigits: 0,
      }).format(value);
    },
  },
};
</script>
<style scoped>
.value {
  font-size: 1.6rem;
  font-weight: 700;
}
.positive {
  color: #16a34a;
}
.negative {
  color: #dc2626;
}
table {
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
thead {
  background: linear-gradient(90deg, #2563eb, #3b82f6);
  color: #fff;
}
tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.1);
}
td,
th {
  vertical-align: middle;
}
</style>
